import React from 'react';
import { DigitalFuneralProvider } from './context/DigitalFuneralContext';
import EkyireAsemApplication from './EkyireAsemApplication';

const EkyireAsem = ({slot}) => {
    return (
        <DigitalFuneralProvider>
            <EkyireAsemApplication slot={slot} />
        </DigitalFuneralProvider>
    );
}
export default EkyireAsem;